import React from "react";
import NavBar from "../components/NavBar";

const OrbisLinesPrivacyPage = ({ language, onLanguageChange, t }) => {
  const collectionItems = t("orbisPrivacy.collection.items") || [];
  const thirdPartyProviders = t("orbisPrivacy.thirdParty.providers") || [];

  return (
    <div
      className="page foody-page trains-page support-page"
      id="orbis-privacy-top"
    >
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[
          { href: "/apps/orbislines", label: t("orbisPrivacy.nav.back") },
          {
            href: "/apps/orbislines/static/support",
            label: t("orbisPrivacy.nav.support"),
          },
        ]}
      />

      <main className="foody-main">
        <section className="foody-hero support-hero">
          <div className="foody-hero-copy">
            <span className="support-pill">{t("orbisPrivacy.badge")}</span>
            <h1>{t("orbisPrivacy.hero.title")}</h1>
            <p>{t("orbisPrivacy.hero.desc")}</p>
            <p className="support-muted">
              {t("orbisPrivacy.hero.effectiveDate")}
            </p>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-grid support-grid">
            <article className="foody-card">
              <h3>{t("orbisPrivacy.collection.title")}</h3>
              <p>{t("orbisPrivacy.collection.desc")}</p>
              <ul className="support-list">
                {collectionItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <p className="support-muted">
                {t("orbisPrivacy.collection.noPersonal")}
              </p>
              <p className="support-muted">
                {t("orbisPrivacy.collection.noLocation")}
              </p>
              <p className="support-muted">{t("orbisPrivacy.collection.noAi")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisPrivacy.firebase.title")}</h3>
              <p>{t("orbisPrivacy.firebase.p1")}</p>
              <p>{t("orbisPrivacy.firebase.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisPrivacy.thirdParty.title")}</h3>
              <p>{t("orbisPrivacy.thirdParty.p1")}</p>
              <p>{t("orbisPrivacy.thirdParty.p2")}</p>
              <ul className="support-list">
                {thirdPartyProviders.map((provider) => (
                  <li key={provider.name}>
                    <a
                      href={provider.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {provider.name}
                    </a>
                  </li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("orbisPrivacy.disclosure.title")}</h3>
              <p>{t("orbisPrivacy.disclosure.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisPrivacy.optOut.title")}</h3>
              <p>{t("orbisPrivacy.optOut.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisPrivacy.retention.title")}</h3>
              <p>{t("orbisPrivacy.retention.desc")}</p>
              <p>
                {t("orbisPrivacy.retention.contactLabel")}
                <br />
                <a href="mailto:support-orbislines@wodaslabs.com">
                  support-orbislines@wodaslabs.com
                </a>
              </p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisPrivacy.children.title")}</h3>
              <p>{t("orbisPrivacy.children.p1")}</p>
              <p>{t("orbisPrivacy.children.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisPrivacy.security.title")}</h3>
              <p>{t("orbisPrivacy.security.p1")}</p>
              <p>{t("orbisPrivacy.security.p2")}</p>
            </article>
          </div>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("orbisPrivacy.contact.title")}</h2>
            <p>
              {t("orbisPrivacy.contact.desc")}
              <br />
              <a href="mailto:support-orbislines@wodaslabs.com">
                support-orbislines@wodaslabs.com
              </a>
            </p>
          </div>
          <div className="store-badges foody-store-badges">
            <a className="btn primary" href="/apps/orbislines/static/support">
              {t("orbisPrivacy.contact.cta")}
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default OrbisLinesPrivacyPage;
